import { ChangeDetectorRef, Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { TranslateModule } from '@ngx-translate/core'
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http'
import { LowerCasePipe } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import { isEmailValid } from '../utils'

type IdentityProviderResponse = {
  providers: string[]
  organizationId: number | null
}

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [FormsModule, MatButton, TranslateModule, LowerCasePipe, MatIcon],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
})
export class LoginPageComponent {
  route = inject(ActivatedRoute)
  http = inject(HttpClient)
  private changeDetector = inject(ChangeDetectorRef)
  email = ''
  password = ''
  identityProviderResponse: IdentityProviderResponse | null = null
  redirectUrl = this.route.snapshot.queryParams['redirect_url']
  showUnknownEmailWarning = this.redirectUrl?.includes('unknown_email') ?? false
  showUserDeactivatedWarning = this.redirectUrl?.includes('user_deactivated') ?? false

  submitEmail() {
    if (!this.isValidEmail) {
      return
    }
    this.http
      .get<IdentityProviderResponse>(`/api/oauth-login-public/authentication-method-from-email?email=${encodeURIComponent(this.email.toLowerCase())}`)
      .subscribe((response) => {
        this.identityProviderResponse = response
        this.changeDetector.detectChanges()
      })
  }

  get isValidEmail() {
    return isEmailValid(this.email)
  }

  isPasswordValid() {
    return this.password.length >= 8
  }

  signInWithPassword() {
    window.location.href = `/api/oauth-login-public/authenticate-with-email/${this.email}?password=${this.password}`
  }
}
